import { PointFeature } from "@models/point";

export const environment = {
  baseUrl: 'https://map-demo.bertburt.com/api/',
  home: new PointFeature({geometry: {type: 'Point', coordinates: [-74.013118, 42.343933]}, properties: {name: '421 Plattekill Rd.'}}),
  title: 'Map Demo'
};